import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Gift } from "lucide-react";

const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const WaiverReport = () => {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/admin/waivers/report").then((x) => setR(x.data)).catch(() => {}); }, []);
  if (!r) return null;
  return (
    <div className="mt-8 bg-white rounded-2xl border border-violet-200 p-5" data-testid="waiver-report">
      <div className="flex items-center gap-2 mb-1"><Gift className="w-5 h-5 text-violet-600" /><p className="font-display font-extrabold text-navy">Fees Waived</p></div>
      <p className="font-display font-extrabold text-3xl text-violet-700" data-testid="waiver-total">{money(r.total)}</p>
      <p className="text-xs text-slate-400 mb-4" data-testid="waiver-count">across {r.count} order{r.count === 1 ? "" : "s"}</p>
      {r.count === 0 ? <p className="text-sm text-slate-400">No fees have been waived yet.</p> : (
        <div className="grid lg:grid-cols-2 gap-5">
          <div>
            <p className="text-xs font-semibold text-slate-500 mb-2">By reason</p>
            {r.by_reason.map((b, i) => (
              <div key={b.reason} className="flex justify-between text-sm py-1.5 border-b border-slate-100" data-testid={`waiver-reason-${i}`}>
                <span className="text-navy">{b.reason} <span className="text-slate-400">· {b.count}</span></span><span className="font-semibold text-violet-700">{money(b.total)}</span>
              </div>
            ))}
          </div>
          <div>
            <p className="text-xs font-semibold text-slate-500 mb-2">Recent waivers</p>
            <div className="max-h-64 overflow-y-auto">
              {r.recent.map((w) => (
                <div key={w.id} className="text-sm py-1.5 border-b border-slate-100" data-testid={`waiver-row-${w.id}`}>
                  <div className="flex justify-between"><span className="font-semibold text-navy">{w.parent_name}</span><span className="text-violet-700 font-semibold">{money(w.amount)}</span></div>
                  <p className="text-xs text-slate-400">{w.kind} · {w.date ? new Date(w.date).toLocaleDateString("en", { month: "short", day: "numeric" }) : ""}{w.waived_by ? ` · by ${w.waived_by}` : ""}{w.reason ? ` · “${w.reason}”` : ""}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
